export default __webpack_public_path__ + "static/media/nagatoshi-shimamura-ZLjMqugKoDA-unsplash.6c877513.jpg";